import { render } from "./sponsors.vue?vue&type=template&id=519b92df&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=519b92df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-519b92df"

export default script